import { addToast } from 'foremanReact/components/ToastsList';

export const showToast = dispatch => toast => dispatch(addToast(toast));



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_openscap-5.2.2-2.fm3_3.el8.noarch/usr/share/gems/gems/foreman_openscap-5.2.2/webpack/helpers/toastHelper.js